import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const pipeInspectionGuard = createFeatureGuard(Feature.PipeInspection);
